// content of this file can not be placed in `gameIds.ts` because after that
// imports from `gameIds.ts` in `*.css.ts` (vanilla extract files) won't work

import { queryParams } from '../../utils/src/functions/queryParams/queryParams';

export const GAME_ID_FROM_URL = queryParams.params.gameId;
